import { useTranslation } from 'react-i18next';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { Preloader } from '@/components/Preloader';
import { EmptyContent } from '@/components/TaxReport/EmptyContent';
import { DATE_FORMAT_DD_MM_YYYY, DATE_FORMAT_MMM_YYYY } from '@/helpers/common';
import s from './index.module.scss';

export const Table = ({ data, isLoading, grouping }) => {
  const { t } = useTranslation('reports');
  return (
    <div className={s.table_wrapper}>
      <div className={s.table_inner}>
        <div className={s.table}>
          <div className={s.table__thead}>
            <div className={s.table__thead_col}>{t('portfolio_data.date')}</div>
            <div className={s.table__thead_col}>
              {grouping ? t('portfolio_data.round') : t('portfolio_data.claim')}
            </div>
            <div
              className={s.table__thead_col}
              title={t('portfolio_data.opening_principal')}
            >
              {t('portfolio_data.opening_principal')}
            </div>
            <div
              className={s.table__thead_col}
              title={t('portfolio_data.invested')}
            >
              {t('portfolio_data.invested')}
            </div>
            <div
              className={s.table__thead_col}
              title={t('portfolio_data.principal_repaid')}
            >
              {t('portfolio_data.principal_repaid')}
            </div>
            <div
              className={s.table__thead_col}
              title={t('portfolio_data.interest_received')}
            >
              {t('portfolio_data.interest_received')}
            </div>
            <div
              className={s.table__thead_col}
              title={t('portfolio_data.closing_principal')}
            >
              {t('portfolio_data.closing_principal')}
            </div>
          </div>

          {isLoading ? (
            <Preloader className={s.preloader} />
          ) : data?.total_count > 0 ? (
            <div className={s.table__tbody}>
              {data.list.map((item, index) => (
                <div key={index} className={s.table__tbody_row}>
                  <div className={s.table__tbody_col}>
                    {prettyDate(item.date, DATE_FORMAT_DD_MM_YYYY)}
                  </div>
                  <div className={s.table__tbody_col}>
                    {grouping
                      ? prettyDate(
                          item.fundraising_start_date,
                          DATE_FORMAT_MMM_YYYY,
                        )
                      : `#${item.loan_id}`}
                  </div>
                  <div className={s.table__tbody_col}>
                    {prettyFloatMoney(item.opening_principal, {
                      decimalPlaces: 2,
                    })}
                  </div>
                  <div className={s.table__tbody_col}>
                    {prettyFloatMoney(item.invested, {
                      decimalPlaces: 2,
                    })}
                  </div>
                  <div className={s.table__tbody_col}>
                    {prettyFloatMoney(item.principal_repaid, {
                      decimalPlaces: 2,
                    })}
                  </div>
                  <div className={s.table__tbody_col}>
                    {prettyFloatMoney(item.interest_received, {
                      decimalPlaces: 2,
                    })}
                  </div>
                  <div className={s.table__tbody_col}>
                    {prettyFloatMoney(item.closing_principal, {
                      decimalPlaces: 2,
                    })}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={s.empty}>
              <EmptyContent />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
